import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Contact = () => {
  const company = {
    name: 'Metal JelJeli',
    email: 'metaljeljeli@gmail.com',
    phone: '+216 28 268 254',
    location: 'Ariana, Tunisia'
  };
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const contactInfo = [
    {
      icon: <FaEnvelope />,
      title: "Email",
      value: company.email,
      link: `mailto:${company.email}`,
      color: "text-gray-900"
    },
    {
      icon: <FaPhone />,
      title: "Téléphone",
      value: company.phone,
      link: `tel:${company.phone}`,
      color: "text-gray-900"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Localisation",
      value: company.location,
      link: "#",
      color: "text-gray-900"
    }
  ];


  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          ref={ref}
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Contact</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Intéressé par nos services ? Contactez-nous pour discuter de votre projet.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12">
                    {/* Informations de Contact (Right) */}
                    <motion.div
            variants={containerVariants}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
          >
            <motion.div
              className="rounded-xl p-6 border border-gray-200 bg-white"
              variants={itemVariants}
            >
              <h3 className="text-2xl font-bold text-gray-800 mb-6 border-b border-gray-200 pb-2">Informations de Contact</h3>
              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <motion.div
                    key={index}
                    className="flex items-center space-x-4 border-b border-gray-200 pb-2.5"
                    variants={itemVariants}
                  >
                    <div className={`w-12 h-12 bg-white rounded-lg shadow-md flex items-center justify-center text-xl ${info.color}`}>
                      {info.icon}
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">{info.title}</h4>
                      <a
                        href={info.link}
                        className="text-gray-600 hover:text-blue-600 transition-colors"
                      >
                        {info.value}
                      </a>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </motion.div>
          {/* Disponibilité & Horaires (Left) */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
          >
            <motion.div
              className="rounded-xl p-6 border border-gray-200 bg-white"
              variants={itemVariants}
            >
              <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
                <h4 className="text-lg font-bold text-gray-800">Disponibilité</h4>
                <div className="flex items-center gap-3 text-sm">
                  <div className="flex items-center gap-2">
                    <span className="inline-block w-2.5 h-2.5 rounded-full bg-green-500"></span>
                    <span className="text-gray-700">Ouvert maintenant</span>
                  </div>
                  <span className="hidden sm:inline text-gray-300">·</span>
                </div>
              </div>
              <ul className="divide-y divide-gray-100 text-sm">
                {[
                  { day: 'Lundi', time: '8:00 - 17:00' },
                  { day: 'Mardi', time: '8:00 - 17:00' },
                  { day: 'Mercredi', time: '8:00 - 17:00' },
                  { day: 'Jeudi', time: '8:00 - 17:00' },
                  { day: 'Vendredi', time: '8:00 - 17:00' },
                  { day: 'Samedi', time: '8:00 - 14:00' },
                  { day: 'Dimanche', time: 'Fermé' }
                ].map((h) => (
                  <li key={h.day} className="py-2 flex justify-between">
                    <span className="text-gray-500">{h.day}</span>
                    <span className="text-gray-800">{h.time}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          </motion.div>


        </div>
      </div>
    </section>
  );
};

export default Contact; 